import { createStore } from 'vuex'
import Status from './status'
import Order from './order'
import axios from 'axios'
import Users from './users'

export default createStore({
  state: {
    custom_error: {
      state: false,
      text: ''
    },
    preloader_button: false,
    file_notification: {
      state: false,
      link: '',
      text: ''
    }
  },
  getters: {
    custom_error: (state) => state.custom_error,
    preloader_button: (state) => state.preloader_button,
    file_notification: (state) => state.file_notification,
  },
  mutations: {
    SET_CUSTOM_ERROR(state, playload) {
      state.custom_error = playload
    },
    SET_PRELOADER_BUTTON(state, playload) {
      state.preloader_button = playload
    },
    SET_FILE_NOTIFICATION(state, playload) {
      state.file_notification = playload
    }
  },
  actions: {
  },
  modules: {
    Status, Order, Users
  }
})
